import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import DashboardContainer from './dashboard/DashboardContainer';
import ApplicationContainerPUV from './application/container/ApplicationContainerPUV';
import ApplicationContainerTricycle from './application/container/ApplicationContainerTricycle';
import SpecialPermitSettingsContainer from './settings/SpecialPermitSettingsContainer';

const SpecialPermitContainer = ({ match }) => {
  const permissions = getJson('permissions');

  return (
    <div className="module-inner">
      <div className="module-inner-title">Special Permit</div>
      <div className="generic-module-nav mb-3">
        {Acl(permissions, ['VIEW SPECIAL PERMIT DASHBOARD']) && (
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/special-permit"
          >
            Dashboard
          </NavLink>
        )}
        {Acl(permissions, ['VIEW SPECIAL PERMIT PUV']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/special-permit/puv-application" // update to /special-permit/puv later
          >
            {/* Applications */}
            PUV
          </NavLink>
        )}
        {Acl(permissions, ['VIEW SPECIAL PERMIT TRICYCLE']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/special-permit/tricycle-application"
          >
            Tricycle
          </NavLink>
        )}
        {Acl(permissions, ['VIEW SPECIAL PERMIT SETTINGS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/special-permit/settings"
          >
            Settings
          </NavLink>
        )}
      </div>
      <Switch>
        {Acl(permissions, ['VIEW SPECIAL PERMIT DASHBOARD']) && (
          <Route exact path={`${match.path}`} component={DashboardContainer} />
        )}
        {Acl(permissions, ['VIEW SPECIAL PERMIT PUV']) && (
          <Route
            path={`${match.path}/puv-application`}
            component={ApplicationContainerPUV}
          />
        )}
        {Acl(permissions, ['VIEW SPECIAL PERMIT TRICYCLE']) && (
          <Route
            path={`${match.path}/tricycle-application`}
            component={ApplicationContainerTricycle}
          />
        )}
        {Acl(permissions, ['VIEW SPECIAL PERMIT SETTINGS']) && (
          <Route
            path={`${match.path}/settings`}
            component={SpecialPermitSettingsContainer}
          />
        )}
      </Switch>
    </div>
  );
};

SpecialPermitContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(SpecialPermitContainer);
